// tslint:disable
export var Extauth2ProfileUpdateStatus;
(function (Extauth2ProfileUpdateStatus) {
    // Update was successful
    Extauth2ProfileUpdateStatus[Extauth2ProfileUpdateStatus["Success"] = 0] = "Success";
    // Update failed
    Extauth2ProfileUpdateStatus[Extauth2ProfileUpdateStatus["Failed"] = 1] = "Failed";
})(Extauth2ProfileUpdateStatus || (Extauth2ProfileUpdateStatus = {}));
Extauth2ProfileUpdateStatus['SUCCESS'] = 0;
Extauth2ProfileUpdateStatus['FAILED'] = 1;
//# sourceMappingURL=Extauth2ProfileUpdateStatus.js.map